import {FactoryProvider, InjectionToken} from '@angular/core'
import * as XLSX from 'xlsx'
import {XLSX$Utils} from 'xlsx'

export const XLSX_PROVIDER = new InjectionToken<XLSX$Utils>('xlsx')

/**
 * The provider
 */
export const xlsxProvider: FactoryProvider = {
  provide: XLSX_PROVIDER,
  useFactory: () => XLSX
}